import StatusReportTable from "../component/statusReport/statusReportTable";

const StatusReportPage = () => {
  return <StatusReportTable />;
};

export default StatusReportPage;
